import { createAction } from '@ngrx/store';

export const isLoading = createAction('[UI component] cargando');
export const stopLoading = createAction('[UI component] Stop Loading');

